import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'missionname'
})
export class MissionNamePipe implements PipeTransform {
    transform(mission: string, ...args: any[]) {
        if (!mission) {
            return '';
        }

        const end = mission.toLowerCase().indexOf('mission');
        if (end >= 0) {
            return mission.slice(0, end).trim();
        }

        // we didn't change anything
        return mission;
    }
}
